/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type IsReplyRecommendationsEnabledError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type IsReplyRecommendationsEnabledResponse = { featureEnabled: boolean };

export type ReplyRecommendationsGetSettingsError = {
  errorType: ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError.ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReplyRecommendationsUpdateSettingsError = {
  errorType: ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError.ErrorType;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ReplyRecommendationsUpdateSettingsResponse = {};

export namespace ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsGetSettingsError {
  export type ErrorType = 'PLACEHOLDER' | unhandledEnumCase;
}

export namespace ComHubspotCvRepliesModelsSettingsAbstractReplyRecommendationsUpdateSettingsError {
  export type ErrorType =
    | 'CONTENT_ASSISTANCE_SETTING_DISABLED'
    | 'CUSTOMER_ANALYSIS_SETTING_DISABLED'
    | 'PORTAL_MISSING_SCOPE'
    | 'MISSING_CUSTOMER_AGENT'
    | unhandledEnumCase;
}

export type GetSettingsV2Response = {
  settings?: ReplyRecommendationsSettingsResponse;
};

export type ReplyRecommendationsSettingsResponse = {
  portalId: number;
  lastUpdatedAt?: number;
  lastUpdatedBy?: number;
  aiAgentUserId?: number;
  contentAssistanceEnabled: boolean;
  customerAnalysisEnabled: boolean;
  replyRecommendationsEnabled: boolean;
  hasExistingDataSources: Default<boolean>;
  hasEligibleKbArticles: Default<boolean>;
};

export type ReplyRecommendationsSettingsUpdateRequest = {
  isEnabled: boolean;
  aiAgentUserId?: number;
  lastUpdatedAt: Default<number>;
};

export type UpdateSettingsV2RequestType =
  Requestify<ReplyRecommendationsSettingsUpdateRequest>;
export type UpdateSettingsV2ResponseType =
  ReplyRecommendationsUpdateSettingsResponse;
export type UpdateSettingsV2ErrorType =
  ReplyRecommendationsUpdateSettingsError & HubspotMetadata;
export const updateSettingsV2Rpc: ChirpAvroRpcDetails<
  UpdateSettingsV2RequestType,
  UpdateSettingsV2ResponseType,
  UpdateSettingsV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'updateSettingsV2',
  auth: 'app',
  fingerprint: 'h-No_L5vTUadh2e2tZ4AoZ2SlnStQRiY',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSettingsResponseType = ReplyRecommendationsSettingsResponse;
export type GetSettingsErrorType = ReplyRecommendationsGetSettingsError &
  HubspotMetadata;
export const getSettingsRpc: ChirpAvroRpcDetails<
  undefined,
  GetSettingsResponseType,
  GetSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'getSettings',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAuMB5dLVlRwFfJOp6dOEjo',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetSettingsV2ResponseType = GetSettingsV2Response;
export type GetSettingsV2ErrorType = ReplyRecommendationsGetSettingsError &
  HubspotMetadata;
export const getSettingsV2Rpc: ChirpAvroRpcDetails<
  undefined,
  GetSettingsV2ResponseType,
  GetSettingsV2ErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'getSettingsV2',
  auth: 'app',
  fingerprint: 'AAAAAAAAAADbRgKQ-703TlfJOp6dOEjo',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type AreReplyRecsEnabledResponseType =
  IsReplyRecommendationsEnabledResponse;
export type AreReplyRecsEnabledErrorType = IsReplyRecommendationsEnabledError &
  HubspotMetadata;
export const areReplyRecsEnabledRpc: ChirpAvroRpcDetails<
  undefined,
  AreReplyRecsEnabledResponseType,
  AreReplyRecsEnabledErrorType,
  false
> = {
  serviceName: 'com.hubspot.cv.replies.rpc.ReplyRecommendationsSettingsService',
  rpcName: 'areReplyRecsEnabled',
  auth: 'app',
  fingerprint: 'AAAAAAAAAACzlfBUgnMg6Lio01o5cyE4',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
